<i18n src="@/locales/models/package.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/components/views/agro_exporter/production/uniq_final_packing_list/show_container/tabs/packages/package_attrs.yml"
  lang="yaml"
></i18n>
<template>
  <div class="sm:col-span-2">
    <label class="label-form">{{
      $t("model.package.exporter_process_crop_variety")
    }}</label>
    <div class="mt-1">
      <select-form
        v-if="crop_varieties.length > 1"
        :options="crop_varieties"
        v-model="exporter_process_crop_variety_id"
        label="name"
      />
      <div class="content-data" v-else>
        {{ this.crop_varieties[0]?.name }}
      </div>
    </div>
  </div>
  <div class="sm:col-span-2">
    <label class="label-form">{{
      $t("model.package.exporter_process_crop_category")
    }}</label>
    <div class="mt-1">
      <select-form
        v-if="crop_categories.length > 1"
        :options="crop_categories"
        v-model="exporter_process_crop_category_id"
        label="name"
      />
      <div class="content-data" v-else>
        {{ this.crop_categories[0]?.name }}
      </div>
    </div>
  </div>

  <div class="sm:col-span-2">
    <label class="label-form">{{
      $t("model.package.exporter_process_crop_package")
    }}</label>
    <div class="mt-1">
      <select-form
        v-if="crop_exp_packages.length > 1"
        :options="crop_exp_packages"
        v-model="exporter_process_crop_package_id"
        label="name"
      />
      <div class="content-data" v-else>
        {{ this.crop_exp_packages[0]?.name }}
      </div>
    </div>
  </div>

  <div class="sm:col-span-2">
    <label class="label-form">{{
      $t("model.package.exporter_process_brand")
    }}</label>
    <div class="mt-1">
      <select-form
        v-if="brands.length > 1"
        :options="brands"
        v-model="exporter_process_brand_id"
        label="name"
      />
      <div class="content-data" v-else>
        {{ this.brands[0]?.name }}
      </div>
    </div>
  </div>
  <div />
</template>

<script>
export default {
  name: "PackageAttrs",
  inheritAttrs: false,
  data() {
    return {
      exporter_process_crop_category_id: null,
      exporter_process_crop_variety_id: null,
      exporter_process_brand_id: null,
      exporter_process_crop_package_id: null,
      crop_categories: [],
      crop_varieties: [],
      crop_exp_packages: [],
      brands: [],
    };
  },
  props: {
    package_item: {
      type: Object,
      required: false,
      default: () => null,
    },
    exporter_process_crop_categories: {
      type: Array,
      required: true,
      default: () => [],
    },
    exporter_process_crop_varieties: {
      type: Array,
      required: true,
      default: () => [],
    },
    exporter_process_crop_packages: {
      type: Array,
      required: true,
      default: () => [],
    },
    exporter_process_brands: {
      type: Array,
      required: true,
      default: () => [],
    },
    quantity: { default: "" },
  },
  created() {
    this.getExportProcessCropCategories();
    this.getExportProcessCropVarieties();
    this.getExportProcessCropPackages();
    this.getExportProcessBrands();
    this.setDefaultData();
  },
  methods: {
    setDefaultData: function () {
      if (!this.package_item) return;

      this.exporter_process_crop_category_id =
        this.package_item.exporter_process_crop_category_id;
      this.exporter_process_crop_variety_id =
        this.package_item.exporter_process_crop_variety_id;
      this.exporter_process_brand_id =
        this.package_item.exporter_process_brand_id;
      this.exporter_process_crop_package_id =
        this.package_item.exporter_process_crop_package_id;
    },
    hasOneItem(arr) {
      return arr.length === 1 ? arr[0].id : null;
    },
    getExportProcessCropCategories: async function () {
      this.crop_categories = this.exporter_process_crop_categories.map(
        (item) => {
          return {
            id: item.id,
            name: item.name,
          };
        }
      );

      this.exporter_process_crop_category_id = this.hasOneItem(
        this.crop_categories
      );
    },
    getExportProcessCropVarieties: async function () {
      this.crop_varieties = this.exporter_process_crop_varieties.map((item) => {
        return {
          id: item.id,
          name: item.name,
        };
      });
      this.exporter_process_crop_variety_id = this.hasOneItem(
        this.crop_varieties
      );
    },
    getExportProcessBrands: async function () {
      this.brands = this.exporter_process_brands;
      if (this.exporter_process_brand_id == null) {
        this.exporter_process_brand_id = this.hasOneItem(this.brands);
      }
    },
    getExportProcessCropPackages: async function () {
      this.crop_exp_packages = this.exporter_process_crop_packages.map(
        (item) => {
          return {
            id: item.id,
            name: `${item.name} de ${item.gross_weight} Kg`,
          };
        }
      );
      this.exporter_process_crop_package_id = this.hasOneItem(
        this.crop_exp_packages
      );
    },
  },
  watch: {
    exporter_process_crop_category_id: function (value) {
      this.$emit("update:exporter_process_crop_category_id", value);
    },
    exporter_process_crop_variety_id: function (value) {
      this.$emit("update:exporter_process_crop_variety_id", value);
    },
    exporter_process_brand_id: function (value) {
      this.$emit("update:exporter_process_brand_id", value);
    },
    exporter_process_crop_package_id: function (value) {
      this.$emit("update:exporter_process_crop_package_id", value);
    },
  },
};
</script>
